/* LOOW homepage: one drawn thread, a rotating USP bar and language selectors. No dependencies. */
(function () {
  if (window.LoowHome) { return; }
  window.LoowHome = true;
  var body = document.body;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches || body.dataset.disableAnimations === 'true';

  function updateDrawerOffset() {
    var banner = document.querySelector('.lh-usp-section');
    var bottom = banner ? banner.getBoundingClientRect().bottom : 0;
    document.documentElement.style.setProperty('--lh-drawer-top', Math.max(0, bottom) + 'px');
  }

  var bannerObserver;
  function observeBanner() {
    if (bannerObserver) { bannerObserver.disconnect(); }
    var banner = document.querySelector('.lh-usp-section');
    if (banner && 'ResizeObserver' in window) {
      bannerObserver = new ResizeObserver(updateDrawerOffset);
      bannerObserver.observe(banner);
    }
    updateDrawerOffset();
  }
  document.addEventListener('drawerOpen', updateDrawerOffset);
  window.addEventListener('resize', updateDrawerOffset);
  document.addEventListener('shopify:section:unload', function () { requestAnimationFrame(observeBanner); });

  function drawThreads(root) {
    var threads = (root || document).querySelectorAll('.lh-thread:not(.is-drawn)');
    if (!threads.length) { return; }
    if (still || !('IntersectionObserver' in window)) {
      threads.forEach(function (t) { t.classList.add('is-drawn'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-drawn'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.5 });
    threads.forEach(function (t) { io.observe(t); });
  }

  function rotateUsp(root) {
    (root || document).querySelectorAll('.lh-usp__track[data-rotate]').forEach(function (track) {
      if (track.dataset.rotating || still) { return; }
      track.dataset.rotating = 'true';
      var pause = false;
      track.addEventListener('pointerdown', function () { pause = true; });
      track.addEventListener('pointerup', function () { pause = false; });
      setInterval(function () {
        if (pause || window.innerWidth >= 990 || document.hidden) { return; }
        var items = track.children.length;
        if (items < 2) { return; }
        var width = track.clientWidth;
        var index = Math.round(track.scrollLeft / width);
        var next = (index + 1) % items;
        track.scrollTo({ left: next * width, behavior: 'smooth' });
      }, Number(track.dataset.rotate) || 4000);
    });
  }

  function selectors(root) {
    if (!window.theme || !theme.Disclosure) { return; }
    (root || document).querySelectorAll('.lh-usp [data-disclosure-locale], .lh-usp [data-disclosure-currency]').forEach(function (el) {
      if (el.dataset.lhReady) { return; }
      el.dataset.lhReady = 'true';
      new theme.Disclosure(el);
    });
  }

  function emaerket(root) {
    var items = (root || document).querySelectorAll('[data-emaerket-rating]');
    if (!items.length) { return; }
    var widget = document.querySelector('script[src^="https://widget.emaerket.dk/widget/"]');
    if (widget) { widget.addEventListener('load', function () { emaerket(root); }, { once: true });
    }
    var tries = 0;
    (function fill() {
      var cfg = window.EmaerketWidgetConfig;
      var data = cfg && cfg.performanceData;
      var score = Number(data && data.reviews_score);
      var count = Number(data && data.customerScore && data.customerScore.reviews);
      if (!Number.isFinite(score) || score <= 0 || score > 5 || !Number.isInteger(count) || count <= 0) {
        if (tries++ < 25) { setTimeout(fill, 400); }
        return;
      }
      items.forEach(function (item) {
        var locale = item.dataset.locale || 'en';
        var rating = score.toLocaleString(locale === 'da' ? 'da-DK' : 'en-GB', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
        var total = Number(count).toLocaleString(locale === 'da' ? 'da-DK' : 'en-GB');
        var text = item.dataset.emaerketRating.replace('[rating]', rating).replace('[count]', total);
        var target = item.querySelector('[data-emaerket-text]') || item;
        target.textContent = text;
        item.hidden = false;
      });
    })();
  }

  function init(root) { drawThreads(root); rotateUsp(root); selectors(root); emaerket(root); observeBanner(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
